<template>
  <div>
    <Layout :pagetitle="$t('Brand')">
      <Table
        :title="$t('Brand')"
        :items="brands"
        :columns="columns"
        :totalItems="totalItems"
        :showButtons="false"
        :searchable="true"
        :editable="true"
        :removable="false"
        :showPagination="true"
        @onSearch="onSearch"
        @onEdit="editBrand"
        @onChangePage="changePage"
      />
    </Layout>
  </div>
</template>

<script>
import Layout from '@/views/layouts/main';
import Table from '@/components/bootstrap/table';

export default {
  components: { Layout, Table },
  data() {
    return {
      search: '',
      page: 1,
      totalItems: 0,
      columns: [
        {
          key: 'name',
          label: this.$t('Name')
        },
        {
          key: 'site',
          label: 'Site URL'
        }
      ],
      brands: []
    };
  },
  mounted() {
    this.getBrands();
  },
  methods: {
    changePage(page) {
      this.page = page;
      this.getBrands();
    },
    getBrands() {
      this.$store.commit('SET_LOADING', true);

      this.$api
        .get('api/brand/all', { search: this.search, page: this.page })
        .then((res) => {
          this.page = 1;
          this.$store.commit('SET_LOADING', false);
          this.brands = res.data?.results || [];
          this.totalItems = res.data.total;
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          console.log(err);
        });
    },
    editBrand(brand) {
      this.$router.push({
        name: 'brandUpdate',
        params: {
          id: brand.id
        }
      });
    },
    onSearch(search = '') {
      this.search = search;
      this.getBrands();
    }
  }
};
</script>

<style></style>
